import { FLAGS } from '@gozoki/feature-flags'
import { createFileRoute } from '@tanstack/react-router'
import { IndustrialConfiguratorPage } from '~/components/routes/industrial-configurator/industrial-configurator-page'
import { FeatureRouteGuard } from '~/components/route-guards'
import { withRoutePermissions } from '~/utils/rbac'
import { industrialConfiguratorSearchSchema } from './-industrial-configurator-search'

export const Route = createFileRoute('/_authenticated/industrial-configurator')({
  staticData: {
    permission: ['read', 'previsions.industrial-configurator.kitchen'],
  },
  validateSearch: industrialConfiguratorSearchSchema,
  component: IndustrialConfiguratorRoute,
})

withRoutePermissions(Route)

function IndustrialConfiguratorRoute() {
  const { tab } = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <FeatureRouteGuard flag={FLAGS.configurateurIndustriel}>
      <IndustrialConfiguratorPage
        tab={tab ?? 'kitchens'}
        onTabChange={(next) => void navigate({ search: (prev) => ({ ...prev, tab: next }) })}
      />
    </FeatureRouteGuard>
  )
}
